/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp */

import { createMedia } from "@artsy/fresnel";
import PropTypes from "prop-types";
import "semantic-ui-css/semantic.css";
import React, { Component } from "react";
import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Segment,
  Sidebar,
  Visibility,
  MessageHeader, Message,
} from "semantic-ui-react";

import Abstract from "./Abstract.js";
// import Results from "./Results.js";
import Comparison from "./Comparison.js";
import overview from "./images/framework-crop-1.jpg";
// import video_website from "./video/video-website.mp4";

import subsection_style from "./style.js";
import Youtube from './YouTube.js';
// import MyCarousel from "./Carousel.js";

const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    mobile: 0,
    tablet: 768,
    computer: 1024,
  },
});

/* Heads up!
 * HomepageHeading uses inline styling, however it's not the best practice. Use CSS or styled
 * components for such things.
 */
const HomepageHeading = ({ mobile }) => (
  <Container fluid>
    {/* <Header
      as="h1"
      content="SinNeRF"
      // inverted
      textAlign="center"
      style={{
        fontSize: mobile ? "2em" : "4em",
        fontWeight: "normal",
        marginBottom: 0,
        marginTop: mobile ? "0.5em" : "1em",
      }}
    /> */}
    <Header
      as="h1"
      // inverted
      textAlign="center"
      style={{
        fontSize: mobile ? "1.5em" : "1.7em",
        fontWeight: "normal",
        marginTop: mobile ? "0.5em" : "1em",
      }}
    >
      <div>
      NeuralLift-360: Lifting An In-the-wild 2D Photo to A 3D Object with 360° Views
      </div>
    </Header>
  </Container>
);

HomepageHeading.propTypes = {
  mobile: PropTypes.bool,
};

/* Heads up!
 * Neither Semantic UI nor Semantic UI React offer a responsive navbar, however, it can be implemented easily.
 * It can be more complicated, but you can create really flexible markup.
 */
class DesktopContainer extends Component {
  state = {};

  hideFixedMenu = () => this.setState({ fixed: false });
  showFixedMenu = () => this.setState({ fixed: true });

  render() {
    const { children } = this.props;
    const { fixed } = this.state;

    return (
      <Media greaterThan="mobile">
        <HomepageHeading />
        {children}
      </Media>
    );
  }
}

DesktopContainer.propTypes = {
  children: PropTypes.node,
};

class MobileContainer extends Component {
  state = {};

  handleSidebarHide = () => this.setState({ sidebarOpened: false });

  handleToggle = () => this.setState({ sidebarOpened: true });

  render() {
    const { children } = this.props;
    const { sidebarOpened } = this.state;

    return (
      <Media as={Sidebar.Pushable} at="mobile">
        <HomepageHeading mobile />

        {children}
      </Media>
    );
  }
}

MobileContainer.propTypes = {
  children: PropTypes.node,
};

const ResponsiveContainer = ({ children }) => (
  /* Heads up!
   * For large applications it may not be best option to put all page into these containers at
   * they will be rendered twice for SSR.
   */
  <MediaContextProvider>
    <DesktopContainer>{children}</DesktopContainer>
    <MobileContainer>{children}</MobileContainer>
  </MediaContextProvider>
);

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
};

const HomepageLayout = ({ mobile }) => (
  <ResponsiveContainer>
    <div>
      <Container text>
        <Grid
          container
          stackable
          verticalAlign="middle"
          columns={6}
          textAlign="center"
          style={{
            fontSize: "1em",
            fontWeight: "normal",
            marginTop: "0.5em",
            marginBottom: "0.5em",
          }}
        >
          {/* <Grid.Row> */}
          {/* <Grid.Column> */}
          <a href="https://ir1d.github.io/" target="_blank" rel="noreferrer">
            Dejia Xu
          </a>
          {/* </Grid.Column> */}
          {/* <Grid.Column> */}
          <a href="https://yifanjiang.net/" target="_blank" rel="noreferrer">
            Yifan Jiang
          </a>
          {/* </Grid.Column> */}
          {/* <Grid.Column> */}
          <a
            href="https://peihaowang.github.io/"
            target="_blank"
            rel="noreferrer"
          >
            Peihao Wang
          </a>
          {/* </Grid.Column> */}
          {/* <Grid.Column> */}
          <a
            href="https://zhiwenfan.github.io/"
            target="_blank"
            rel="noreferrer"
          >
            Zhiwen Fan
          </a>
          {/* </Grid.Column> */}
          {/* <Grid.Column> */}
          <a
            href="https://oden.utexas.edu/people/directory/Yi-Wang/"
            target="_blank"
            rel="noreferrer"
          >
            Yi Wang
          </a>
          <a
            href="https://express.adobe.com/page/CAdrFMJ9QeI2y/"
            target="_blank"
            rel="noreferrer"
          >
            Zhangyang Wang
          </a>
          {/* </Grid.Column> */}
          {/* </Grid.Row> */}
          <div>
            The University of Texas at Austin
          </div>
          <br />
        </Grid>
      </Container>
      <Grid
        container
        stackable
        verticalAlign="middle"
        columns={2}
        width={10}
        textAlign="center"
        style={{
          fontSize: "1.2em",
          fontWeight: "normal",
          marginTop: "0.5em",
          marginBottom: "0.5em",
        }}
      >
        <Grid.Row>
          <Grid.Column columns={2}>
            <Button primary icon>
              <a
                href="https://arxiv.org/abs/2211.16431"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "white",
                }}
              >
                <Icon name="book" />
                {" Paper"}
              </a>
            </Button>
            <Button primary icon>
              <a
                href="https://github.com/Ir1d/NeuralLift-360"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "white",
                }}
              >
                <Icon name="github" />
                {" Code"}
              </a>
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Container text>
      <Youtube></Youtube>
      {/* <Header as="h2" textAlign="center" style={subsection_style}>
          Overview
        </Header> */}
        {/* <MyCarousel mobile={mobile} ></MyCarousel> */}
        
        <Image src={overview} style={subsection_style}></Image>
        <p>
        <b>TL;DR:</b> An overview of our NeuralLift-360. We learn to recover a 3D object from a single reference image. We derive a prior distillation loss for CLIP-guided diffusion prior and utilize rough depth estimation in the wild with the help of a ranking loss.
        </p>
        <Abstract mobile={mobile} />
        {/* <Header as="h2" textAlign="center" style={subsection_style}>
          Video
        </Header>
        <video
          src={video_website}
          width="100%"
          loop="loop"
          autoplay=""
          controls
        ></video> */}
        {/* <Results /> */}
        <Comparison />
        <Header as="h2" textAlign="center" style={subsection_style}>
          Citation
        </Header>
        <p style={{ paddingBottom: "0.5em", overflow: "auto" }}>
          If you want to cite our work, please use:
          <pre>
            <code>
              {`@InProceedings\{Xu_2022_neuralLift,
    author = \{Xu, Dejia and Jiang, Yifan and Wang, Peihao and Fan, Zhiwen and Wang, Yi and Wang, Zhangyang\},
    title = \{NeuralLift-360: Lifting An In-the-wild 2D Photo to A 3D Object with 360° Views\},
    journal={arXiv preprint arXiv:2211.16431},
    year={2022}
\}`}
            </code>
          </pre>
        </p>
        <Header as="h2" textAlign="center" style={subsection_style}>
        Relevant Works
        </Header>
        <Message info color='teal'>
    <MessageHeader><a href="https://vita-group.github.io/4DGen/" target="_blank" rel="noreferrer">
    4DGen: Grounded 4D Content Generation with Spatial-temporal Consistency
    </a></MessageHeader>
    We introduce grounded 4D content generation. We identify static 3D assets and monocular video sequences as key components in constructing the 4D content. 
  </Message>
        <Message info color='teal'>
    <MessageHeader> <a href="https://vita-group.github.io/3D-Mode-Collapse/" target="_blank" rel="noreferrer">
    Taming Mode Collapse in Score Distillation for Text-to-3D Generation
    </a></MessageHeader>
    We derive an entropy-maximizing score distillation rule that fosters view diversity and address the multi-face problem for text-to-3D generation.
  </Message>
  <Message info color='teal'>
    <MessageHeader> <a href="https://vita-group.github.io/SteinDreamer/" target="_blank" rel="noreferrer">
    SteinDreamer: Variance Reduction for Text-to-3D Score Distillation via Stein Identity
    </a></MessageHeader>
    We adopt control variate method constructed by Stein identity to reduce variance in Monte Carlo estimation for text-to-3D score distillation.
  </Message>
  <br></br>
      </Container>
    </div>
  </ResponsiveContainer>
);

export default HomepageLayout;
